/* KARDELEN Relaunch – kleine Helfer für die kd-* Sektionen */
(() => {
  /* Vorteilsleiste: auf schmalen Bildschirmen nacheinander einblenden */
  if (!customElements.get('kd-rotator')) {
    customElements.define('kd-rotator', class extends HTMLElement {
      connectedCallback() {
        const items = [...this.children];
        if (items.length < 2) return;
        let i = 0;
        const ms = parseInt(this.dataset.interval || '4000', 10);
        this._t = setInterval(() => {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, ms);
      }
      disconnectedCallback() { clearInterval(this._t); }
    });
  }
  if (!customElements.get('kd-slider')) customElements.define('kd-slider', class extends HTMLElement {});

  const money = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });

  /* Aktionspreis-Box: Preis bei Variantenwechsel aktualisieren */
  const updatePromo = (variantId) => {
    document.querySelectorAll('[data-kd-promo]').forEach((box) => {
      const prices = JSON.parse(box.querySelector('[data-kd-promo-prices]').textContent);
      const id = variantId || box.closest('.product')?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      if (!id || prices[id] == null) return;
      const factor = parseFloat(box.dataset.factor);
      box.querySelector('[data-kd-promo-price]').textContent = money(Math.round(prices[id] * factor));
      box.querySelector('[data-kd-promo-old]').textContent = money(prices[id]);
    });
  };
  document.addEventListener('variant:changed', (e) => e.detail?.variant && updatePromo(String(e.detail.variant.id)));

  /* Lieferzeit: Werktage (Mo–Fr) ab heute als Datumsbereich */
  const addWorkdays = (date, days) => {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
  document.querySelectorAll('[data-kd-delivery]').forEach((el) => {
    const now = new Date();
    const min = addWorkdays(now, parseInt(el.dataset.min, 10));
    const max = addWorkdays(now, parseInt(el.dataset.max, 10));
    const out = el.querySelector('[data-kd-delivery-range]');
    if (out) out.textContent = `Voraussichtlich ${fmt(min)} – ${fmt(max)}`;
  });

  /* „Das passt dazu“: Zusatzartikel direkt in den Warenkorb, Drawer öffnen */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-kd-addon]');
    if (!btn || btn.classList.contains('is-added')) return;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${window.themeVariables?.routes?.cartAddUrl || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: btn.dataset.kdAddon, quantity: 1 }),
      });
      if (!res.ok) throw new Error(await res.text());
      btn.classList.add('is-added');
      const cart = await (await fetch(`${window.themeVariables?.routes?.cartUrl || '/cart'}.js`)).json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: true } }));
    } catch (err) {
      console.warn('KD addon', err);
    } finally {
      btn.classList.remove('is-loading');
    }
  });
})();
